import React, { Fragment, useState } from "react";

import Dropdown, { DropdownItem } from "@common/components/Dropdown/Dropdown";
import { CenteredCell } from "@common/components/GridTable/GridTable";
import Paragraph from "@common/components/Paragraph/Paragraph";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { Invoice, InvoiceStatus } from "@common/models/billing";
import { dateStringForMappingFiles } from "@common/models/helpers/time/creationTime";
import { vars } from "@common/styles";
import identifiers from "@common/util/identifiers.json";

import * as Styled from "./ReceiptRow.styles";

interface Props {
  receipt: Invoice;
}

export const ReceiptRow = ({ receipt }: Props) => {
  const isBorderRed: boolean = receipt.status === InvoiceStatus.OPEN && !!receipt.receipt_url;

  const DropdownButton = () => {
    const [isOpened, setIsOpened] = useState(false);
    if (!receipt.receipt_url) return <CenteredCell />;

    const handleClick = () => {
      window.open(receipt.receipt_url);
      setIsOpened(!isOpened);
    };

    return (
      <Styled.CellEnd $isBordered={isBorderRed}>
        <Dropdown
          setIsOpened={setIsOpened}
          isOpened={isOpened}
          testId={identifiers["billing.button.options"]}
        >
          <DropdownItem
            onClick={handleClick}
            testId={identifiers["billing.dropdown.open"]}
          >
            Open
          </DropdownItem>
        </Dropdown>
      </Styled.CellEnd>
    );
  };

  return (
    <Fragment>
      <Styled.CenteredCell
        data-testid={identifiers["billing.info.receipt.date"]}
        $isBordered={isBorderRed}
        $position={"left"}
      >
        <Paragraph color={vars.colors.grey30}>
          {receipt.finalized_at ? dateStringForMappingFiles(new Date(receipt.finalized_at)) : ""}
        </Paragraph>
      </Styled.CenteredCell>
      <Styled.CenteredCell
        data-testid={identifiers["billing.info.receipt.date"]}
        $isBordered={isBorderRed}
        $position={"middle"}
      >
        <Paragraph color={vars.colors.grey30}>{`$${receipt.total.toString().slice(0, -2)}.${receipt.total
          .toString()
          .slice(-2)}`}</Paragraph>
      </Styled.CenteredCell>
      <Tooltip
        text={receipt.description}
        position="top"
        offset={0}
      >
        <Styled.CenteredCell
          $isBordered={isBorderRed}
          $position={"middle"}
        >
          <Paragraph color={vars.colors.grey30}>{receipt.description}</Paragraph>
        </Styled.CenteredCell>
      </Tooltip>
      <DropdownButton />
    </Fragment>
  );
};
